export default __webpack_public_path__ + "static/media/circle-filled-red.5b000c81.svg";